<template>
    <div class="mt-5">
        <h3>{{ $t('connect.arrayFieldDisabled') }}</h3>
        <div class="box-field-view flex-row">
            <template v-for="(item, index) in listFieldChecked">
                <el-checkbox v-model="item.checked" :label="item.label" class="ml-0" border :key="'field' + index" @change="changeFieldDisabled()"></el-checkbox>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    name: 'array-field-disable',
    props: {
        listField: { required: true },
        arrayFieldDisabled: { required: true }
    },
    data() {
        return {
            listFieldChecked: []
        };
    },
    computed: {
        watchFieldDisable() {
            return [this.listField, this.arrayFieldDisabled];
        }
    },
    watch: {
        watchFieldDisable: {
            deep: true,
            immediate: true,
            handler() {
                let arrayField = Object.values(this.listField);
                if (!arrayField) return;
                this.listFieldChecked = arrayField.map((value) => ({
                    code: value.code,
                    label: value.label,
                    checked: false
                }));
                if (!this.arrayFieldDisabled) return;
                this.listFieldChecked.forEach((itemFieldChecked) => {
                    itemFieldChecked.checked = false;
                });
                this.arrayFieldDisabled.forEach((itemFieldDisabled) => {
                    this.listFieldChecked.forEach((itemFieldChecked) => {
                        if (itemFieldDisabled.code === itemFieldChecked.code) {
                            itemFieldChecked.checked = true;
                        }
                    });
                });
            }
        }
    },
    methods: {
        changeFieldDisabled() {
            let arrayFieldDisabledMap =
                this.listFieldChecked
                    ?.filter((item) => !!item.checked)
                    .map((value) => ({
                        code: value.code,
                        label: value.label
                    })) ?? null;
            this.$emit('update:arrayFieldDisabled', arrayFieldDisabledMap);
        }
    }
};
</script>
